import React, { Component } from "react";
import "./Navbar.css";
class Navbar extends Component {
  render() {
    return (
      <>
        <nav class="navbar navbar-expand-lg nav-bar">
          <div class="container-fluid">
            <a class="navbar-brand text-light" href="/">
              GIMS
            </a>
            <button
              class="navbar-toggler bg-light"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div
              class="collapse container navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a
                    class="nav-link active text-light"
                    aria-current="page"
                    href="/"
                  >
                    Home
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link text-light" href="/Delivery">
                    Delivery Areas
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link text-light" href="/Careers">
                    Careers
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link text-light" href="/Press">
                    Press
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link text-light" href="/Customer">
                    Customer Support
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </>
    );
  }
}
export default Navbar;
